<p>
  By default, once you publish this product, it will be available at all your
  locations. If you would like to restrict the availability of this product to
  certain locations or Location groups, you can do so by adding exclusions
  below.
</p>

<h6>Exclude from</h6>
<mat-form-field class="w-full" appearance="fill">
  <mat-label>Search Store</mat-label>
  <input
    type="text"
    placeholder="Search Store"
    matInput
    [formControl]="availabilityControl"
    [matAutocomplete]="auto"
    [(ngModel)]="storeSelectedTemp"
  />
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    (optionSelected)="addStoreSelected($event)"
  >
    <mat-option disabled *ngIf="(filteredOptions | async)?.length === 0">
      <mat-icon 
        class="material-symbols-outlined">
        error
      </mat-icon>
      No matching stores or groups found.
    </mat-option>
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{ option.Name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<h6 class="fontColor">{{ storeSelectedSet.size }} location added</h6>

<mat-chip-listbox>
  <mat-chip
    *ngFor="let storeSelected of storeSelectedSet"
    color="primary"
    selected
    (removed)="removeExcludeStore(storeSelected)"
  >
    {{ storeSelected.Name }} - {{ storeSelected.City }}
    <button matChipRemove>
      <mat-icon>close</mat-icon>
    </button>
  </mat-chip>
</mat-chip-listbox>

<!-- Availability Display Section -->
<div class="availability-container" *ngIf="storeSelectedSet.size > 0">
  <div class="availability-section">
    <div class="availability-value">{{ storeSelectedSet.size }}</div>
    <div class="availability-label">Excluded Locations</div>
  </div>
  
  <div class="availability-section">
    <div class="availability-value">{{ options.length - storeSelectedSet.size }}</div>
    <div class="availability-label">Available Locations</div>
  </div>
</div>
